export const defaultState: Fields = {
  isModalOpen: false,
  promoCode: 'FLEETSKU',
};

interface Fields {
  isModalOpen: boolean;
  promoCode: string;
}
